import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    tableCellClasses,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Strings } from "../../resources/i18n/i18n";

// 1. StyledTableCell implementation
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 10,
        backgroundColor: "#d5d5d5",
        color: theme.palette.common.black,
        fontWeight: 'bold',
        borderRight: "1px solid #bbb",
        padding: '8px',
        position: 'sticky',
        top: 0,
        zIndex: 1,
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        lineHeight: 1.2,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 10,
        borderRight: "1px solid #bbb",
        padding: '8px',
        overflow: "hidden",
         whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
    }
}));

// GenericDatabaseTable
class GenericDatabaseTable extends React.Component {

    renderTableHeader = () => {
        const { columns } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {columns.map(col => (
                        <StyledTableCell
                            key={col.key}
                            align="center"
                            sx={{
                                width: col.width,
                                minWidth: col.width,
                                maxWidth: col.width,
                            }}

                            title={col.label}
                        >
                            {col.label || Strings(col.name)}
                        </StyledTableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    };

    renderTableBody = () => {
        const { data, columns } = this.props;
        return (
            <TableBody>
                {data.map((row, rowIndex) => (
                    <TableRow key={rowIndex} hover>
                        {columns.map(col => {
                            const cellValue = row[col.key];
                            return (
                                <StyledTableCell
                                    key={col.key}
                                    align="center"
                                    sx={{
                                        width: col.width,
                                        minWidth: col.width,
                                        maxWidth: col.width,
                                        
                                    }}
                                    title={cellValue !== null && cellValue !== undefined ? String(cellValue) : "-"}
                                >
                                    {col.render
                                        ? col.render(cellValue, row, rowIndex)
                                        : cellValue !== null && cellValue !== undefined
                                            ? String(cellValue)
                                            : "-"
                                    }
                                </StyledTableCell>
                            );
                        })}
                    </TableRow>
                ))}
            </TableBody>
        );
    };

    render() {
        return (
            <div className='d-flex justify-content-center mx-2 pt-2 pb-3' style={{ maxHeight: "25em" }}>
                {this.props.data && this.props.data.length > 0 ?
                    <TableContainer
                        component={Paper}
                        sx={{ border: "1px solid #ccc", width: "100%" }}
                    >
                        <Table aria-label="generic database table" sx={{
                            tableLayout: "fixed",
                            width: "100%",
                        }}>
                            {this.renderTableHeader()}
                            {this.renderTableBody()}
                        </Table>
                    </TableContainer>
                    :
                    <div className='noRecordsFound noBranchRecords'>
                        {Strings("NoRecordsFound")}
                    </div>
                }
            </div>
        );
    }
}

export default GenericDatabaseTable;
